import type { CartItem } from '@src/domains/cart';
import type { DetailedSaleItem } from '@src/domains/orders';
import { groupTariffsById, groupTariffsByType } from '@src/domains/tariffs';

import { isCartLineItem, type SummaryLineItem } from './summaryLineItem';

export type SummaryTariffDisplayRow = {
  key: string;
  quantity: number;
  name: string;
  currentCents: number;
  originalCents?: number;
};

const getOriginalCentsIfDiscounted = (amountCents: number, originalAmountCents?: number) =>
  originalAmountCents && originalAmountCents > amountCents ? originalAmountCents : undefined;

export const buildCartTariffRows = (item: CartItem): SummaryTariffDisplayRow[] =>
  groupTariffsByType(item.tariffs).map((tariff) => {
    const cartTariff = item.tariffs.find((entry) => entry.tariff.type.id === tariff.tariff.type.id);
    const unit = cartTariff?.costPreview.unitPriceCurrencyInfo;
    const currentCents = unit?.amountCents ?? 0;

    return {
      key: tariff.tariff.type.id,
      quantity: tariff.quantity,
      name: tariff.tariff.type.name,
      currentCents,
      originalCents: getOriginalCentsIfDiscounted(currentCents, unit?.originalAmountCents),
    };
  });

export const buildSaleTariffRows = (item: DetailedSaleItem): SummaryTariffDisplayRow[] =>
  groupTariffsById(item.tariffs).map((tariff) => {
    const unit = tariff.unitPriceCurrencyInfo;

    return {
      key: tariff.id,
      quantity: tariff.quantity,
      name: tariff.name,
      currentCents: unit.amountCents,
      originalCents: getOriginalCentsIfDiscounted(unit.amountCents, unit.originalAmountCents),
    };
  });

export const getSummaryTariffRows = (item: SummaryLineItem): SummaryTariffDisplayRow[] =>
  isCartLineItem(item) ? buildCartTariffRows(item) : buildSaleTariffRows(item);
